export default "__VITE_ASSET__vvta58rn__"